import CustomFontStyle from "./CustomFontStyle";

export default CustomFontStyle;
